import { GlobalAxios } from "../axios/axios-config";
import {
  INewSendLimitMonth,
  ISendLimitMonth,
} from "../models/send-limit-month";

const SEND_LIMIT_MONTH_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/SendLimitMonth";

export const createSendLimitMonth = (item: INewSendLimitMonth) => {
  return GlobalAxios.post(SEND_LIMIT_MONTH_ROUTE, item);
};

export const getSendLimitMonthById = (id: string) => {
  return GlobalAxios.get<ISendLimitMonth>(SEND_LIMIT_MONTH_ROUTE + "/" + id);
};

export const updateSendLimitMonthById = ({
  item,
  id,
}: {
  item: INewSendLimitMonth;
  id: string;
}) => {
  return GlobalAxios.put(SEND_LIMIT_MONTH_ROUTE + "/" + id, item);
};
